<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import Swal from "sweetalert2";
import attributeProduct from "./attributeProduct.vue";
import { usePermissions } from '@/composables/usePermissions';   // ← Added this line

export default {
    page: {
        title: "Products Details",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            role: localStorage.getItem('role'),
            title: "Products Details",
            items: [
                {
                    text: "Device Management",
                    href: "/",
                },
                {
                    text: "Products Details",
                    active: true,
                },
            ],
            product_info: [],
            categorylist: [],
            devicemodelList: [],
            colorList: [],
            capacityList: [],
            product_name: '',
            model_id: '',
            category_id: '',
            capacity_id: '',
            color_id: '',
            color_hex_code: '',
            owned: '',
            status: '0', // Default to enable
            image: '',
            ButtonSeen: true,
            url: '',
            // New Image Upload States
            thumbnailFile: null,
            thumbnailPreview: '',
            isDragging: false,
        };
    },
    
    setup() {
        // Initialize permissions composable
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },

        get_branch_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'product/edit/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.product_info = response.data;
                    if (this.product_info.length > 0) {
                        this.product_name = this.product_info[0].product_name;
                        this.image = this.product_info[0].thumbnail;
                        this.model_id = this.product_info[0].model_id;
                        this.category_id = this.product_info[0].category_id;
                        this.capacity_id = this.product_info[0].capacity_id;
                        this.color_id = this.product_info[0].color_id;
                        this.color_hex_code = this.product_info[0].color_hex_code;
                        this.owned = this.product_info[0].owned;
                        this.status = this.product_info[0].status ? this.product_info[0].status.toString() : '0';
                    }
                } 
                else {
                    Swal.fire({
                        title: "Error",
                        text: 'No record found.',
                        icon: 'warning',
                        showConfirmButton: false,
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching product:', error);
                Swal.fire({
                    title: "Error",
                    text: error.message || 'Failed to fetch product details',
                    icon: 'error',
                });
            });
        },

        update_product(e) {
            e.preventDefault();
            
            // Determine if we're creating or updating
            const isEditing = typeof this.$route.params.id !== 'undefined';
            
            // Check permissions
            if (isEditing && !this.permissions.canUpdate?.value) {
                Swal.fire({
                    title: "Update Denied",
                    text: "You don't have permission to update products.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            if (!isEditing && !this.permissions.canCreate?.value) {
                Swal.fire({
                    title: "Create Denied",
                    text: "You don't have permission to create new products.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            // Validate required fields
            if (!this.product_name || !this.category_id || !this.model_id || !this.capacity_id || !this.color_id) {
                Swal.fire({
                    title: "Validation Error",
                    text: "Please fill in all required fields.",
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            const formData = new FormData();
            formData.append('product_name', this.product_name);
            formData.append('model_id', this.model_id);
            formData.append('category_id', this.category_id);
            formData.append('capacity_id', this.capacity_id);
            formData.append('color_id', this.color_id);
            formData.append('color_hex_code', this.color_hex_code || '');
            formData.append('owned', this.owned || '');
            formData.append('status', this.status);

            if (this.thumbnailFile) {
                formData.append('thumbnail', this.thumbnailFile);
            }

            // Determine API endpoint
            this.url = isEditing 
                ? process.env.VUE_APP_API_BASEURL + 'product/update/' + this.$route.params.id
                : process.env.VUE_APP_API_BASEURL + 'product/create';

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': 'Bearer ' + localStorage.getItem('jwt')
                }
            };

            axios.post(this.url, formData, config)
            .then(response => {
                if (response.status === 200) {
                    Swal.fire({
                        title: isEditing ? 'Updated Successfully' : 'Created Successfully',
                        text: response.data.message || 'Operation completed successfully',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    
                    // If creating new, reset form
                    if (!isEditing) {
                        this.resetForm();
                    }
                    
                    // Navigate back after successful operation
                    setTimeout(() => {
                        this.$router.push({ name: 'productList' });
                    }, 1600);
                } else {
                    Swal.fire({
                        title: "Operation Failed",
                        text: response.data.message || 'Operation failed',
                        icon: 'warning',
                        showConfirmButton: false,
                    });
                }
            })
            .catch(error => {
                console.error('API Error:', error);
                Swal.fire({
                    title: "Error",
                    text: error.response?.data?.message || 'An error occurred. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            });
        },

        // Reset form to initial state
        resetForm() {
            this.product_name = '';
            this.model_id = '';
            this.category_id = '';
            this.capacity_id = '';
            this.color_id = '';
            this.color_hex_code = '';
            this.owned = '';
            this.status = '0';
            this.image = '';
            this.thumbnailFile = null;
            this.thumbnailPreview = '';
        },

        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(e) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImagePreview(files[0]);
        },
        createImagePreview(file) {
            if (!file.type.match('image.*')) {
                Swal.fire({
                    title: "Invalid File Type",
                    text: "Please select an image file (PNG, JPG, JPEG, WEBP).",
                    icon: 'warning'
                });
                return;
            }
            this.thumbnailFile = file;
            this.thumbnailPreview = URL.createObjectURL(file);
            this.removeImageFlag = false;
        },
        onDragOver(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        onDragLeave() {
            this.isDragging = false;
        },
        onDrop(e) {
            e.preventDefault();
            this.isDragging = false;
            const files = e.dataTransfer.files;
            if (files.length) {
                this.createImagePreview(files[0]);
            }
        },
        removeThumbnail() {
            this.thumbnailFile = null;
            this.thumbnailPreview = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },

        showLargeImage() {
            const imageUrl = this.thumbnailPreview || this.image;
            if (!imageUrl) return;
            
            Swal.fire({
                imageUrl: imageUrl,
                imageAlt: 'Product Image',
                showCloseButton: true,
                showConfirmButton: false,
                imageWidth: '100%',
                imageHeight: 'auto',
                customClass: {
                    image: 'img-fluid rounded'
                }
            });
        },

        // Delete product method
        deleteProduct() {
            if (!this.permissions.canDelete?.value) {
                Swal.fire({
                    title: "Delete Denied",
                    text: "You don't have permission to delete products.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.delete(process.env.VUE_APP_API_BASEURL + 'product/delete/' + this.$route.params.id)
                    .then(response => {
                        Swal.fire({
                            title: 'Deleted!',
                            text: response.data.message || 'Product has been deleted.',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.$router.push({ name: 'productList' });
                        });
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Error',
                            text: error.response?.data?.message || 'Failed to delete product.',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });
                    });
                }
            });
        },

        //raw data----------------------------------------------------------
        get_category(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'category/raw_data')
            .then(response => {
                if (response) {
                    this.categorylist = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
            });
        },

        get_model(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device_model/raw_data')
            .then(response => {
                if (response) {
                    this.devicemodelList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching models:', error);
            });
        },

        get_capacity(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'capacity/raw_data')
            .then(response => {
                if (response) {
                    this.capacityList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching capacities:', error);
            });
        },

        get_color(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'color/raw_data')
            .then(response => {
                if (response) {
                    this.colorList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching colors:', error);
            });
        },

        selectNewCategory(category_id) {
            this.get_category();
            this.category_id = category_id;
        },

        selectNewModel(model_id) {
            this.get_model();
            this.model_id = model_id;
        },

        selectNewCapacity(capacity_id) {
            this.get_capacity();
            this.capacity_id = capacity_id;
        },

        selectNewColor(color_id) {
            this.get_color();
            this.color_id = color_id;
        },
        //raw data----------------------------------------------------------

        imageRoot(){
            return process.env.VUE_APP_IMAGE_BASEURL;
        },
        
        // Check if user can add attributes (category, model, etc.)
        canAddAttributes() {
            return this.permissions.canCreate?.value || this.permissions.canUpdate?.value;
        },
    },

    computed: {
        // Determine if we're in edit mode
        isEditMode() {
            return typeof this.$route.params.id !== 'undefined';
        },
        
        // Button text based on mode and permissions
        submitButtonText() {
            if (this.isEditMode && this.permissions.canUpdate?.value) {
                return 'Update Product';
            } else if (!this.isEditMode && this.permissions.canCreate?.value) {
                return 'Create Product';
            }
            return 'Submit';
        },
        
        // Button color based on action
        submitButtonColor() {
            return this.isEditMode ? 'btn-warning' : 'btn-primary';
        },
        
        // Page title based on mode
        pageTitle() {
            return this.isEditMode ? 'Edit Product' : 'Create New Product';
        },
    },

    components: {
        Layout,
        PageHeader,
        attributeProduct,
    },

    mounted() { 
        // Set page title based on mode
        this.title = this.pageTitle;
        
        // Update breadcrumb items
        if (this.isEditMode) {
            this.items[1].text = 'Edit Product';
        } else {
            this.items[1].text = 'Create Product';
        }
        
        // Load data if in edit mode and user has permission
        if (this.isEditMode) {
            if (this.permissions.canRead?.value || this.permissions.canUpdate?.value) {
                this.get_branch_by_id();
            } else {
                // Redirect or show error if no permission
                Swal.fire({
                    title: "Access Denied",
                    text: "You don't have permission to view this product.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                }).then(() => {
                    this.$router.go(-1);
                });
            }
        }
        
        // Load dropdown data
        this.get_category();
        this.get_model();
        this.get_capacity();
        this.get_color();
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- Permission check -->
    <div v-if="!permissions.canRead?.value && !permissions.canCreate?.value && !permissions.canUpdate?.value" 
         class="alert alert-danger m-3">
      <i class="ri-error-warning-line align-middle me-2"></i>
      You don't have permission to access this page.
    </div>
    
    <div v-else class="row">
      <div class="col-lg-12">
        <div class="card">

          <div class="card-body py-4 md:py-6">
            <div class="row">
              <!-- Form Section -->
              <div class="col-lg-8 mx-auto">
                <div>
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div v-if="isEditMode">
                        <h4>
                          <span class="badge badge-soft-primary badge-border">{{ product_name }}</span>
                        </h4>
                        <hr class="my-4 text-muted">
                      </div>
                      
                      <div class="live-preview">
                        <form @submit="update_product" class="row g-3">
                          <!-- Product Name -->
                          <div class="col-md-12">
                            <label for="product_name" class="form-label">Product Name <span class="text-danger">*</span></label>
                            <input v-model='product_name' 
                                   type="text" 
                                   class="form-control" 
                                   id="product_name"
                                   :disabled="!permissions.canUpdate?.value && isEditMode"
                                   required />
                          </div>

                          <!-- Category -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="category" class="form-label">Category <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addCategoryModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="category_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Category ---</option>
                              <option v-for="(item, index) in categorylist" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          
                          <!-- Model -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="model" class="form-label">Model <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addModelModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="model_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Model ---</option>
                              <option v-for="(item, index) in devicemodelList" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.model_name }}
                              </option>
                            </select>
                          </div>

                          <!-- Capacity -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="capacity" class="form-label">Capacity <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addCapacityModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="capacity_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Capacity ---</option>
                              <option v-for="(item, index) in capacityList" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          
                          <!-- Color -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="color" class="form-label">Color <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addColorModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="color_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Color ---</option>
                              <option v-for="(item, index) in colorList" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>

                          <!-- Color Hex Code -->
                          <div class="col-md-6">
                            <label for="color_hex_code" class="form-label">Color Hex Code</label>
                            <input v-model='color_hex_code' 
                                   type="text" 
                                   class="form-control" 
                                   id="color_hex_code"
                                   :disabled="!permissions.canUpdate?.value && isEditMode" />
                          </div>
                          
                          <!-- Pre Owned -->
                          <div class="col-md-6">
                            <label for="owned" class="form-label">Pre Owned</label>
                            <input v-model='owned' 
                                   type="text" 
                                   class="form-control" 
                                   id="owned"
                                   :disabled="!permissions.canUpdate?.value && isEditMode" />
                          </div>
                          
                          <!-- Status -->
                          <div class="col-md-12" v-if="isEditMode">
                            <label for="status" class="form-label">Status</label>
                            <div class="list-group">
                              <label class="list-group-item" :class="{'opacity-50': !permissions.canUpdate?.value}">
                                <input class="form-check-input fs-14 mt-0 align-middle me-1"
                                       name="status"
                                       v-model="status"
                                       type="radio"
                                       value="0"
                                       :disabled="!permissions.canUpdate?.value" />
                                Enable
                              </label>
                              <label class="list-group-item" :class="{'opacity-50': !permissions.canUpdate?.value}">
                                <input class="form-check-input fs-14 mt-0 align-middle me-1"
                                       name="status"
                                       v-model="status"
                                       type="radio"
                                       value="1"
                                       :disabled="!permissions.canUpdate?.value" />
                                Disable
                              </label>
                            </div>
                          </div>

                          <!-- Product Image -->
                          <div class="col-md-12">
                            <label for="product_image_input" class="form-label">Product Image <span v-if="!isEditMode" class="text-danger">*</span></label>
                            <input 
                              id="product_image_input"
                              type="file" 
                              ref="fileInput"
                              class="form-control mb-2" 
                              accept="image/*"
                              @change="onFileChange"
                              :disabled="!permissions.canUpdate?.value && isEditMode"
                            />
                            
                            <!-- Preview Area -->
                            <div v-if="thumbnailPreview || image" class="position-relative border rounded p-2 bg-light d-inline-block mt-2" style="max-width: 200px;">
                               <img 
                                 :src="thumbnailPreview || image" 
                                 alt="Preview" 
                                 class="img-fluid rounded"
                                 style="max-height: 150px; object-fit: contain; cursor: pointer;"
                                 @click="showLargeImage"
                                 title="Click to view larger image"
                               />
                               <button 
                                 v-if="thumbnailPreview && !(isEditMode && !permissions.canUpdate?.value)"
                                 type="button" 
                                 class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 p-1 d-flex align-items-center justify-content-center"
                                 style="width: 24px; height: 24px; border-radius: 50%;"
                                 @click="removeThumbnail"
                                 title="Cancel New Selection"
                               >
                                 <i class="ri-close-line"></i>
                               </button>
                             </div>
                          </div>
                          
                          <!-- Action Buttons -->
                          <div class="col-12">
                            <div class="text-end">
                              <a @click="$router.go(-1)" class="btn btn-light me-2">
                                <i class="ri-arrow-go-back-line align-middle me-1"></i> Back
                              </a>
                              
                              <!-- Submit button with dynamic text and permission check -->
                              <button v-if="(isEditMode && permissions.canUpdate?.value) || (!isEditMode && permissions.canCreate?.value)"
                                      type="submit" 
                                      class="btn" 
                                      :class="submitButtonColor"
                                      :disabled="(!product_name || !category_id || !model_id || !capacity_id || !color_id || (!isEditMode && !thumbnailFile))">
                                <i class="ri-save-line align-middle me-1"></i> {{ submitButtonText }}
                              </button>
                              
                              <!-- Disabled button if no permission -->
                              <button v-else
                                      type="button"
                                      class="btn btn-secondary"
                                      disabled>
                                <i class="ri-forbid-line align-middle me-1"></i> No Permission
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>                  
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    
    <!-- Attribute Modals (only if user has permission) -->
    <attributeProduct 
      v-if="canAddAttributes()"
      @category-added="selectNewCategory" 
      @model-added="selectNewModel" 
      @capacity-added="selectNewCapacity" 
      @color-added="selectNewColor">
    </attributeProduct>
    
  </Layout>
</template>

<style scoped>
.opacity-50 {
  opacity: 0.5;
}

.badge-border {
  border: 1px solid #dee2e6;
}

.btn:disabled {
  cursor: not-allowed;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item input:disabled {
  cursor: not-allowed;
}

.badge {
  font-size: 0.75em;
}
</style>